import { api } from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { SalesPerformanceAdapter } from '@/adapters/sales-performance.adapter';
import type { ApiResponse } from '@/types';
import type { SalesPerformance, SalesPerformanceResponseDto } from '@/types/sales-performance.types';

export interface SalesPerformanceParams {
  start: string; end: string; timezone: string; bu_id?: string; currency?: string;
}
export const salesPerformanceService = {
  async get(params: SalesPerformanceParams, signal?: AbortSignal): Promise<SalesPerformance> {
    const { data } = await api.get<ApiResponse<SalesPerformanceResponseDto>>(API_ENDPOINTS.SALES_AGENT.PERFORMANCE, { params, signal });
    return SalesPerformanceAdapter.fromApi(data.data);
  }
};
